"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCaption = void 0;
var date_fns_1 = require("date-fns");
/**
 * The default formatter for the caption.
 */
function formatCaption(month, options) {
    return date_fns_1.format(month, 'LLLL y', options);
}
exports.formatCaption = formatCaption;
//# sourceMappingURL=formatCaption.js.map